module.exports = __webpack_public_path__ + "arrow-footer.png?1ca791c9932627986f500b36b8d601ab";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/arrow-footer.png
// module id = 152
// module chunks = 0